// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"eb47935b","667":"e57a798e","977":"f464b880"}[chunkId] + ".chunk.js";
};